export default function genererRelance() {
  return {
    piedPage: null,
    texte: null,
    signataire: null,
    logoTailleX: null,
    logoTailleY: null,
  };
}
